// RU-STRATDRILL SD-1: a strategy name that opens the shared drill-down drawer (never the row underneath).
import { openStrategyDrawer } from "@/lib/strategyDrawer";

export default function StrategyNameButton({ id, name, testid, className = "", children }) {
  const label = children ?? name ?? "Strategy";
  if (!id) return <span className={className}>{label}</span>;
  return (
    <button type="button" data-testid={testid} title="Open strategy details"
            onClick={(e) => { e.stopPropagation(); openStrategyDrawer({ id, name }); }}
            className={`text-left hover:underline underline-offset-2 cursor-pointer ${className}`}>
      {label}
    </button>
  );
}
